import api from './api';

const adminService = {
  getDashboard: () => api.get('/admin/dashboard'),
  getRevenue: () => api.get('/admin/revenue'),

  // Users
  getUsers: (params) => api.get('/admin/users', { params }),
  toggleUserActive: (userId) => api.put(`/admin/users/${userId}/toggle-active`),

  // Orders
  getOrders: (params) => api.get('/admin/orders', { params }),

  // Stores
  getStores: (params) => api.get('/admin/stores', { params }),
  approveStore: (storeId, isApproved) => api.put(`/admin/stores/${storeId}/approve`, { isApproved }),
};

export default adminService;
